import EntityBaseRepository from '@/api/misc/EntityBaseRepository';

export default class UserRepository extends EntityBaseRepository {

}
